import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShow4", component(opts));
  editor.BlockManager.add("slideShow4", block(opts));
};